import React from "react";
import { Star, Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { REVIEWS } from "@/lib/business";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

export default function Reviews() {
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="relative py-20 md:py-28 bg-[#0B132B] text-white overflow-hidden"
    >
      <div className="absolute top-0 left-0 right-0 h-1 bg-[#D32F2F]" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-12">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-10 bg-[#D32F2F]" />
              <span className="font-mono-label text-[#D32F2F]">
                Real Customers · Real Reviews
              </span>
            </div>
            <h2 className="font-display text-3xl md:text-5xl font-bold leading-[1.05]">
              Trusted by Your{" "}
              <span className="text-[#D32F2F]">Neighbors.</span>
            </h2>
            <p className="mt-5 text-white/75 text-lg leading-relaxed">
              Don't take our word for it — here's what Madison Heights drivers
              say about their experience with Veteran's Auto Repair Center.
            </p>
          </div>

          <div className="flex items-center gap-3">
            <div className="flex">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={`avg-star-${i}`} className="w-6 h-6 fill-[#D32F2F] text-[#D32F2F]" />
              ))}
            </div>
            <div>
              <div className="font-display text-2xl font-bold">5.0 / 5.0</div>
              <div className="font-mono-label text-white/60">Average Rating</div>
            </div>
          </div>
        </div>

        <Carousel
          opts={{ align: "start", loop: true }}
          className="w-full"
          data-testid="reviews-carousel"
        >
          <CarouselContent className="-ml-4">
            {REVIEWS.map((r) => (
              <CarouselItem
                key={r.name}
                data-testid={`review-card-${r.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="pl-4 md:basis-1/2 lg:basis-1/3"
              >
                <article className="h-full bg-white/[0.04] border border-white/15 p-7 md:p-8 flex flex-col">
                  <Quote className="w-8 h-8 text-[#D32F2F] mb-4" strokeWidth={2.5} />
                  <div className="flex mb-4" aria-label={`${r.stars} out of 5 stars`}>
                    {Array.from({ length: r.stars }).map((_, i) => (
                      <Star
                        key={`${r.name}-star-${i}`}
                        className="w-4 h-4 fill-[#D32F2F] text-[#D32F2F]"
                      />
                    ))}
                  </div>
                  <p className="text-white/90 text-base md:text-lg leading-relaxed flex-1">
                    "{r.text}"
                  </p>
                  <div className="mt-6 pt-5 border-t border-white/15 flex items-center justify-between">
                    <div>
                      <div className="font-display font-semibold text-white">
                        {r.name}
                      </div>
                      <div className="font-mono-label text-[#D32F2F]">
                        Verified Customer
                      </div>
                    </div>
                    <div className="w-10 h-10 border border-white/25 flex items-center justify-center font-display font-bold text-white">
                      {r.name.charAt(0)}
                    </div>
                  </div>
                </article>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="mt-8 flex items-center justify-start gap-3">
            <CarouselPrevious
              data-testid="reviews-prev-btn"
              className="static translate-y-0 bg-transparent border-2 border-white/30 text-white hover:bg-[#D32F2F] hover:border-[#D32F2F] hover:text-white rounded-none w-12 h-12"
            >
              <ChevronLeft className="w-5 h-5" />
            </CarouselPrevious>
            <CarouselNext
              data-testid="reviews-next-btn"
              className="static translate-y-0 bg-transparent border-2 border-white/30 text-white hover:bg-[#D32F2F] hover:border-[#D32F2F] hover:text-white rounded-none w-12 h-12"
            >
              <ChevronRight className="w-5 h-5" />
            </CarouselNext>
          </div>
        </Carousel>
      </div>
    </section>
  );
}
